import Carousel                               from "flowbite/lib/esm/components/carousel";
import { findElem }                           from "@TsUtils//helpers";
import type { CarouselItem, CarouselOptions } from "flowbite";
import type {
    TypeAdvantagesDataItems, TypeDeliveryStepsDataItems,
    TypePartnersList, TypeReviewsList
} from "@ViewPages/Main/Components/commonTypes";

type TypeDataList = TypeDeliveryStepsDataItems | TypeAdvantagesDataItems | TypePartnersList | TypeReviewsList;

type TypeHandleCarousel = {
    idOrClassNameCarouseEl : string,
    idOrClassNameIndicatorEls : string,
    idOrClassNameCarouselItemsEls : string,
    data_list : TypeDataList,
    isMobileDevice : boolean,
};

export class MainCarousel {
    _carouselInstance : Carousel | null = null;
    _startX : number = 0;
    _startY : number = 0;
    _endX : number = 0;
    _endY : number = 0;
    _isMobileDevice : boolean;
    _idOrClassNameCarouseEl : string;
    _idOrClassNameIndicatorEls : string;
    _idOrClassNameCarouselItemsEls : string;
    _data_list : TypeDataList;

    constructor(parameters : TypeHandleCarousel) {
        this._idOrClassNameCarouseEl = parameters.idOrClassNameCarouseEl;
        this._idOrClassNameIndicatorEls = parameters.idOrClassNameIndicatorEls;
        this._idOrClassNameCarouselItemsEls = parameters.idOrClassNameCarouselItemsEls;
        this._data_list = parameters.data_list;
        this._isMobileDevice = parameters.isMobileDevice;
    }

    handleCarousel() : void {
        const carouselElement : HTMLElement = findElem<HTMLElement>(this._idOrClassNameCarouseEl) as HTMLElement,
            carouselItems : CarouselItem[] = [],
            indicatorItems : CarouselItem[] = [];

        for (let stepIndex in this._data_list) {
            indicatorItems.push(<CarouselItem>{
                position: +stepIndex,
                el: findElem<HTMLElement>(this._idOrClassNameIndicatorEls + (+stepIndex + 1)),
            });

            carouselItems.push(<CarouselItem>{
                position: +stepIndex,
                el: findElem<HTMLElement>(this._idOrClassNameCarouselItemsEls + (+stepIndex + 1)),
            })
        }

        const options : CarouselOptions = {
            defaultPosition: 0,
            indicators: {
                activeClasses: 'bg-custom-green-600',
                inactiveClasses:
                    'bg-custom-green-600/50 scale-75 hover:bg-custom-green-600',
                items: indicatorItems
            },
        };

        this._carouselInstance = new Carousel(carouselElement, carouselItems, options);
    };

    handleTouchStart(e : TouchEvent) : void {
        const touch = e.touches[0];

        this._startX = touch.clientX;
        this._startY = touch.clientY;
    };

    handleTouchMove(e : TouchEvent) : void {
        if (this._isMobileDevice) {
            e.preventDefault(); // Prevent scrolling
        }
    };

    handleSwipe() : void {
        const deltaX = this._endX - this._startX,
            deltaY = this._endY - this._startY;

        // use Math.abs(deltaX) <= 0.8 || Math.abs(deltaY) <= 0.8
        // so that the user does not swipe the slider when clicking on it
        if (!this._carouselInstance || Math.abs(deltaX) <= 0.8 || Math.abs(deltaY) <= 0.8) {
            return;
        }

        if (Math.abs(deltaX) > Math.abs(deltaY)) {
            // Horizontal swipe
            deltaX > 0 ? this._carouselInstance.prev() : this._carouselInstance.next();
        } else {
            // Vertical swipe (additional feature)
            deltaY > 0 ? this._carouselInstance.prev() : this._carouselInstance.next();
        }
    };

    handleTouchEnd(e : TouchEvent) : void {
        if (!this._isMobileDevice) {
            return;
        }

        const touch = e.changedTouches[0];

        this._endX = touch.clientX;
        this._endY = touch.clientY;

        this.handleSwipe();
    };
}
